import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { deleteDialog } from '../actions';
import { Dialog as PaperDialog, Portal, Provider as PaperProvider } from 'react-native-paper';
import { Button, Text } from 'native-base';
import { Platform, StyleSheet, Dimensions, ScrollView } from 'react-native';
import { C } from '../constants';

let deviceWidth = Dimensions.get('window').width;
let deviceHeight = Dimensions.get('window').height;

import WebView from './WebView';

class Dialog extends Component {
  handlerHideDialog = () => this.props.dispatch(deleteDialog());

  componentDidUpdate() {
    // shitfix Не нашёл друго способа поменять css свойство
    if (Platform.OS === 'web') {
      setTimeout(() => {
        let cover = document.querySelector('[aria-live="polite"]');
        cover && cover.style.setProperty("position", "fixed");
      }, 100);
    }
  }


  render() {
    const { dialog } = this.props;

    if (!dialog.value) {
      return null;
    }

    return (
      dialog.visible ? <PaperProvider style={styles.paperHolder}>
        <Portal style={styles.paperHolder}>
          <PaperDialog
            style={styles.paper}
            visible={dialog.visible}
            onDismiss={this.handlerHideDialog}>
            <Text style={styles.title}>{dialog.label}</Text>

            {/* <div dangerouslySetInnerHTML={{ __html: dialog.value }}></div> */}
            <ScrollView style={styles.scrollView}><WebView content={dialog.value} /></ScrollView>

            <PaperDialog.Actions style={{padding: 0}}>
              <Button
                style={styles.button}
                onPress={this.handlerHideDialog}
              ><Text style={{ 
                width: "100%", 
                marginTop: Platform.OS !== 'web' ? 18: 0,
                textAlign: "center"
                 }}>OK</Text></Button>
            </PaperDialog.Actions>
          </PaperDialog>
        </Portal>
      </PaperProvider> : null
    );
  }
}

function mapStateToProps(state) {
  return {
    dialog: state.dialog
  };
}

Dialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dialog: PropTypes.object
};

export default connect(mapStateToProps)(Dialog);


let maxHeight = deviceWidth <= C.MIN_WIDTH ? Math.floor(deviceHeight - 75) : Math.floor(deviceHeight - 150);


const styles = StyleSheet.create({
  paperHolder: {
    position: 'absolute'
  },
  paper: {
    borderRadius: 0,
    position: 'absolute',
    marginTop: Platform.OS === 'ios' ? 50 : 10,
    right: 0,
    left: 0,
    maxHeight: maxHeight,
    overflow: 'hidden',
    top: Platform.Os === 'web' ? 40 : 0
  },
  button: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: Platform.OS !== 'web' ? 11 : 0,
    marginBottom: 0,
    marginRight: 0,
    marginLeft: 0,
    backgroundColor: '#e2051c',
    borderRadius: 0,
    height: 54,
    width: "100%"
  },
  scrollView: {
    maxHeight: maxHeight,
    paddingTop: 0,
    paddingRight: deviceWidth <= C.MIN_WIDTH ? 10 : 60,
    paddingBottom: 10,
    paddingLeft: deviceWidth <= C.MIN_WIDTH ? 10 : 60,
    overflow: 'hidden',
  },
  title: {
    marginLeft: deviceWidth <= C.MIN_WIDTH ? 10 : 60,
    marginRight: 15,
    marginTop: deviceWidth <= C.MIN_WIDTH ? 15 : 54,
    marginBottom: 6,
    fontSize: 20,
    fontWeight: "700",
    color: "#0067a2"
  },
  item: {
    margin: 5
  }
});
